export default __webpack_public_path__ + "static/media/homeScene_5.6c815ca6.png";